import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AppInformationService, GenesisUnitOfWork, ReportService, SessionInformationService } from 'app/core/core.module';
import { HistoryService } from 'app/core/history.service';
import { Dealer } from 'app/core/model/dealer';
import { PackingSlip } from 'app/core/model/packing-slip';
import { SharedModule } from 'app/shared/shared.module';
import { DxDataGridComponent } from 'devextreme-angular';
import _ from 'lodash';
import { BsModalService } from 'ngx-bootstrap/modal';
import { PackingSlipDialogComponent } from '../packing-slip-dialog/packing-slip-dialog.component';

@Component({
    selector: 'app-pack-slip-history',
    templateUrl: './pack-slip-history.component.html',
    styleUrls: ['./pack-slip-history.component.scss'],
    standalone: false
})
export class PackSlipHistoryComponent implements OnInit {
    filter: any;
    packSlips: any[];
    dealers: Dealer[];

    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    onExporting = SharedModule.onExporting;

    constructor(
        private uow: GenesisUnitOfWork,
        private router: Router,
        private reportService: ReportService,
        private sessionInfo: SessionInformationService,
        private appInfo: AppInformationService,
        private historyService: HistoryService,
        private modalService: BsModalService
    ) {}

    async ngOnInit() {
        this.dealers = await this.uow.getDealers();
        const filter = this.sessionInfo.getItem('pack-slip-history-filter');
        if (filter) {
            this.filter = filter;
            await this.search();
        } else this.filter = {};
    }

    async search() {
        this.appInfo.pleaseWaitShow();
        this.packSlips = await this.historyService.getPackSlipHistory(this.filter);
        this.sessionInfo.setItem('pack-slip-history-filter', this.filter);
        this.appInfo.pleaseWaitHide();
    }

    clear() {
        this.filter = {};
    }

    // this method is used to clear the selection when the user searches for something
    onOptionChanged(e) {
        if (e.fullName === 'searchPanel.text') {
            e.component.__searchChanged = true;
        }
        const filterCheck = _.includes(e.fullName, 'filterValue');
        if (filterCheck) {
            this.dataGrid.instance.clearSelection();
        }
    }

    // this method is used to clear the selection when the user searches for something
    onContentReady(e) {
        if (e.component.__searchChanged) {
            //__searchChanged is for the search box
            e.component.__searchChanged = false;
            this.dataGrid.instance.clearSelection();
        }
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                location: 'before',
                template: 'toolbarButtons',
            },
            {
                template: 'toolbarText',
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'refresh',
                    elementAttr: { title: 'Reset Grid Layout' },
                    onClick: () => {
                        e.component.state({});
                    },
                },
                location: 'after',
            }
        );
    }

    async onRowDoubleClick(e) {
        this.open(e.data);
    }

    open(invoice: any) {
        // if (!invoice) return;
        // this.router.navigate([`/invoices/${invoice.id}`]);
    }

    async openOrder(salesOrderNumber: number) {
        const order = (await this.uow.getOrdersByInvoiceNumbers([salesOrderNumber]))[0];
        if (!order) return;
        this.router.navigate([`/sales-orders/${order.id}`]);
    }
    async openInvoice(invoiceNumber: number) {
        const entity = await this.uow.getInvoiceByInvoiceNumber(invoiceNumber);
        if (!entity) return;
        this.router.navigate([`/invoices/${entity.id}`]);
    }

    async openPackingSlip(packingSlipId: number) {
        this.router.navigate([`/packingslips/${packingSlipId}`]);
    }

    async print(slipInfo: any) {
        const packingSlip = (await this.uow.getPackSlipByNumber(slipInfo.packingSlipNumber)) as PackingSlip;
        if (!packingSlip) return;

        if (packingSlip.reportGuid === null) {
            packingSlip.reportGuid = crypto.randomUUID();
            await this.uow.commit();
        }

        this.reportService.openPackingSlip([packingSlip.reportGuid]);
    }

    async editPackSlip() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (selectedRows.length !== 1) return;
        const packSlipId = selectedRows[0].id;
        const packSlip = await this.uow.packingSlips.byId(packSlipId);

        const modalRef = this.modalService.show(PackingSlipDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                packingSlip: packSlip,
                disableSlipNumber: true,
                mode: 'edit',
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                this.appInfo.pleaseWaitShow();
                await this.search();
                this.appInfo.pleaseWaitHide();
            }
            modalRef.hide();
        });
    }
}
